import type from './types';

const INITIAL_STATE = {
  loading: true,
  list: [],
  newsList: [],
  newsLoading: false,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case type.LIST_FETCHED:
      return {
        ...state,
        list: action.payload,
        loading: false,
      };
    case type.LIST_LOAD:
      return { ...state, loading: action.payload };
    case type.NEWS_LIST_FETCHED:
      return {
        ...state,
        newsList: [...state.newsList, ...action.payload],
        newsLoading: false,
      };
    case type.NEWS_LIST_LOAD:
      return { ...state, newsLoading: action.payload };
    case type.NEWS_LIST_SET:
      return { ...state, newsList: action.payload };
    default:
      return state;
  }
};
